import {useCallback, useEffect, useState} from 'react';

const useAnimatedVisibility = props => {
    const {visible = false, timeout = 5000, showTimeout = timeout, hideTimeout = timeout} = props,
        [state, setState] = useState({
            mounted: false,
            visible: false,
            showing: false,
            hiding: false,
        });

    useEffect(() => {
        if (visible) {
            if (!state.mounted) setState({...state, mounted: true, visible: false, showing: false, hiding: false});
            else if (!state.visible) setState({...state, visible: true, showing: true, hiding: false});
        } else {
            if (state.visible) setState({...state, visible: false, showing: false, hiding: true});
        }
    }, [visible, state]);

    useEffect(() => {
        if (state.showing) {
            let timeout = setTimeout(() => setState({...state, showing: false}), showTimeout);
            return () => clearTimeout(timeout);
        }
    }, [state]);

    useEffect(() => {
        if (state.hiding) {
            let timeout = setTimeout(() => setState({...state, hiding: false, mounted: false}), hideTimeout);
            return () => clearTimeout(timeout);
        }
    }, [state]);

    const onTransitionEnd = useCallback(
        () => setState({...state, showing: false, hiding: false, mounted: visible}),
        [state, visible]
    );

    return {...state, onTransitionEnd};
};

export default useAnimatedVisibility;
